import { useRef, useImperativeHandle, forwardRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "../../../assets/css/preview.module.scss";
import { ANNOTATION_KEY_FRAMES } from "./AnnotationArrows/Main";

interface ProgressControlProps {
  stageRef: React.MutableRefObject<number>;
  setStage: (stage: number) => void;
}

export interface ProgressControlHandle {
  goToSlide: (index: number) => void;
}

const ProgressControl = forwardRef<ProgressControlHandle, ProgressControlProps>(({ setStage }, ref) => {
  const sliderRef = useRef<Slider>(null);

  useImperativeHandle(ref, () => ({
    goToSlide: (index: number) => {
      sliderRef.current?.slickGoTo(index);
    }
  }), []);

  // Note: We don't sync slider with stageRef changes because the ref doesn't trigger re-renders
  // The slider is the source of truth for stage changes via beforeChange callback

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (_current: number, next: number) => {
      // Update stage when slider changes
      if (next !== undefined) {
        setStage(next);
      }
    },
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          arrows: false
        }
      }
    ]
  };

  function NextArrow(props: any) {
    const { onClick } = props;
    return (
      <i
        className={styles.customNextArrow}
        onClick={onClick}
      />
    );
  }

  function PrevArrow(props: any) {
    const { onClick } = props;
    return (
      <i
        className={styles.customPrevArrow}
        onClick={onClick}
      />
    );
  }

  // Convert PROGRESS_STAGES_DATA object to array for mapping
  const stages = ANNOTATION_KEY_FRAMES;

  return (
    <Slider ref={sliderRef} {...settings}>
      {stages.map((stageData) => (
        <div key={stageData.labelHeading}>
          <div className={styles.canvasSize}>
              Empty div to maintain slider height and prevent layout shift when stage data changes
          </div>
          <div className={styles.stageDataTitle}>{stageData.labelHeading}</div>
          <div className={styles.stageDataSubTitle}>{stageData.labelBody}</div>
        </div>
      ))}
    </Slider>
  );
});

export default ProgressControl;

